const locale = {
	APPLICATIONS: 'Applications',
	HOME: 'Home',
	CLEAN: 'Clean',
	CLEANING_SESSIONS: 'Cleaning Sessions',
    ROOMIE_AI: 'RoomieAI',
    ROOMS_ASSIGNMENT: 'Tasks Management',
	MAINTENANCE: 'Maintenance',
	HELP_CENTER: 'Help Center',
	FAQ: 'FAQs',
	GUIDES: 'Guides',
	SUPPORT: 'Support',
	SIGN_IN: 'Sign In',
	LOADING: 'Loading',
	SETTINGS: 'Settings',
};

export default locale;
